import React from "react";

function DecentralizedExHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover text-center flex items-start"
        style={{
          backgroundImage:
            "url(assets/img/bg/decentralized_exchange_development_img.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "80vh",
        }}
      >
        <div className="container mx-auto px-4 pt-[270px] pb-20">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
              Decentralized Exchange (DEX) Development
            </h2>

            <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
              Xeer Technology specializes in building secure, transparent, and
              user-friendly decentralized exchange (DEX) where users can trade
              cryptocurrencies directly without relying on intermediaries. These
              exchanges operate on blockchain and enable peer-to-peer trading
              through smart contracts, ensuring full control over user funds.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default DecentralizedExHero;
